var map = {
	"./afb-color.svg": 644,
	"./alb-color.svg": 645,
	"./all.svg": 646,
	"./amb-color.svg": 647,
	"./arg.svg": 648,
	"./aus.svg": 649,
	"./bank-icon.svg": 650,
	"./bankdemo-color.svg": 651,
	"./bel.svg": 652,
	"./bimb-color.svg": 653,
	"./bkr-color.svg": 654,
	"./bpay-color.svg": 655,
	"./bra.svg": 656,
	"./bsn-color.svg": 657,
	"./can.svg": 658,
	"./checked-blue.webp": 1643,
	"./checked-green.png": 659,
	"./checked-white.png": 660,
	"./cimb-color.svg": 661,
	"./cimb-icon.svg": 662,
	"./citi-color.svg": 663,
	"./cmr.svg": 664,
	"./crc.svg": 665,
	"./cro.svg": 666,
	"./den.svg": 667,
	"./ecu.svg": 668,
	"./eng.svg": 669,
	"./esp.svg": 670,
	"./fav-blue.svg": 671,
	"./fav-blue.webp": 1644,
	"./fav-gray.png": 672,
	"./fav-gray.svg": 673,
	"./fav-gray.webp": 1645,
	"./fav-icon-active.png": 674,
	"./fav-icon.png": 675,
	"./fav-red.png": 676,
	"./fra.svg": 677,
	"./game-icon.svg": 678,
	"./games-active-m.svg": 679,
	"./games-m.webp": 1646,
	"./ger.svg": 680,
	"./gha.svg": 681,
	"./gxbank-color.svg": 682,
	"./hlb-color.svg": 683,
	"./hlb-icon.svg": 684,
	"./hsbc-color.svg": 685,
	"./irn.svg": 686,
	"./jpn.svg": 687,
	"./kor.svg": 688,
	"./ksa.svg": 689,
	"./kwh-color.svg": 690,
	"./latest-icon-active.png": 691,
	"./latest-icon.png": 692,
	"./lc-active-m.svg": 693,
	"./lc-icon.svg": 694,
	"./lc-m.webp": 1647,
	"./lottery-active-m.svg": 695,
	"./lottery-icon.svg": 696,
	"./lottery-m.svg": 697,
	"./love.svg": 698,
	"./mar.svg": 699,
	"./mbb-color.svg": 700,
	"./mex.svg": 701,
	"./ned.svg": 702,
	"./ocbc-color.svg": 703,
	"./ocbc-icon.svg": 704,
	"./p2p-active-m.svg": 705,
	"./p2p-icon.svg": 706,
	"./p2p-m.svg": 707,
	"./pbb-color.svg": 708,
	"./pol.svg": 709,
	"./por.svg": 710,
	"./price-high.svg": 711,
	"./price-low.svg": 712,
	"./qat.svg": 713,
	"./rhb-color.svg": 714,
	"./rhb-icon.svg": 715,
	"./scb-color.svg": 716,
	"./sen.svg": 717,
	"./slot-active-m.svg": 718,
	"./slot-icon.svg": 719,
	"./slot-m.webp": 1648,
	"./sport-active-m.svg": 720,
	"./sport-m.webp": 1649,
	"./sports-icon.svg": 721,
	"./srb.svg": 722,
	"./star.svg": 723,
	"./sui.svg": 724,
	"./tng-color.svg": 725,
	"./trx-icon.svg": 726,
	"./trx.svg": 727,
	"./tun.svg": 728,
	"./uob-color.svg": 729,
	"./uru.svg": 730,
	"./usa.svg": 731,
	"./usdc.svg": 732,
	"./usdt.svg": 733,
	"./ustd-icon.svg": 734,
	"./wal.svg": 735,
	"./x33-logo-b.svg": 736,
	"./x33-square-icon.svg": 737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 463;